<template>
  <div id="activities">
    <el-row class="topMargin">
      <v-client-table class="hiaTable" v-loading="loading" element-loading-spinner="atom-audit-loader" ref="activitiesGrid" id="activitiesGrid"
        :data="activityAuditActivities.filter(x => x.activityAuditTypeId === selectedType.activityAuditTypeId)" :columns="activityColumns" :options="activityOptions" uniqueKey="activityAuditActivityId">
        <div slot="filter__isInactive">
          <input type="checkbox" @change="$refs.activitiesGrid.setFilter({isInactive: $event.target.checked})">
        </div>
        <template slot="name" slot-scope="props">
          <div class="el-input--mini">
            <input class="el-input__inner" type="text" v-model="props.row.name" @change="updateActivity(props.row)">
          </div>
        </template>
        <template slot="isInactive" slot-scope="props">
          <input :key="props.row.activityAuditActivityId" type="checkbox" v-model="props.row.isInactive" @change="updateActivity(props.row)">
        </template>
        <template slot="delete" slot-scope="props">
          <div style="text-align: center;">
            <i class="el-icon-close delete-button" @click="deleteActivity(props.row)"></i>
          </div>
        </template>
      </v-client-table>
    </el-row>

    <el-form label-position="left" label-width="150px" size="mini" style="margin-top: 10px;">
      <el-popover placement="right" ref="newActivityPopover" :title="`Add Activity to ${selectedType.name}`" width="300" trigger="click">
        <el-form :model="addActivityForm" ref="addActivityForm" size="mini" :rules="addActivityForm.rules" label-position="top" label-width="180px" @submit.native.prevent>
          <el-form-item prop="name" label="Activity Name">
            <el-input v-model="addActivityForm.name" size="mini"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button-group>
              <el-button class="hiaButton" plain round size="mini" type="text" @click="closeNewActivityPopover()">Cancel</el-button>
              <el-button class="hiaButton" plain round size="mini" @click="addActivity('addActivityForm')">Add</el-button>
            </el-button-group>
          </el-form-item>
        </el-form>

        <el-button slot="reference" class="hiaButton" plain round size="mini" icon="el-icon-plus">Add Activity</el-button>
      </el-popover>
    </el-form>
  </div>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'
  import HiaAuthorization from '@/mixins/hiaAuthorization'
  import hiaTable from '@/mixins/hiaTable'

  export default {
    name: 'ActivityAuditActivities',
    mixins: [hiaTable, HiaAuthorization],
    props: ['selectedType'],
    data() {
      return {
        loading: false,
        activityColumns: ['name', 'isInactive', 'delete'],
        activityOptions: {
          filterByColumn: false,
          filterable: false,
          sortable: ['name'],
          orderBy: {
            column: 'name',
            ascending: true
          },
          headings: {
            isInactive: 'Inactive',
            delete: function (h) {
              return ''
            },
            name: 'Activity'
          },
          perPage: 10,
          texts: {
            filter: '',
            filterBy: '...'
          },
          highlightMatches: true,
          sortIcon: { is: 'none' }
        },
        addActivityForm: {
          name: '',
          rules: {
            name: [
              { required: true, message: 'Please Input Name', trigger: 'none' }
            ]
          }
        }
      }
    },
    methods: {
      ...mapActions('managedLists/activityAuditActivities/', ['GET_ACTIVITY_AUDIT_ACTIVITIES', 'POST_ACTIVITY_AUDIT_ACTIVITY', 'DELETE_ACTIVITY_AUDIT_ACTIVITY', 'PUT_ACTIVITY_AUDIT_ACTIVITY']),
      ...mapMutations('dropdowns/', ['REMOVE_CACHED_DROPDOWN']),
      addActivity(refName) {
        this.$refs[refName].validate(async (valid) => {
          if (valid) {
            try {
              this.loading = true
              const payload = {
                activity: {
                  activityAuditTypeId: this.selectedType.activityAuditTypeId,
                  name: this.addActivityForm.name,
                  isInactive: false
                }
              }
              await this.POST_ACTIVITY_AUDIT_ACTIVITY(payload)
              this.$refs[refName].resetFields()
              this.closeNewActivityPopover()
              this.loading = false
              this.$message({
                message: 'Activity Added',
                type: 'success'
              })
            } catch (err) {
              this.loading = false
              this.$message({
                message: `Error Adding Activity: ${err.message}`,
                type: 'error'
              })
            }
          }
        })
      },
      async updateActivity(activity) {
        const index = this.activityAuditActivities.findIndex(x => x.activityAuditActivityId === activity.activityAuditActivityId)
        this.$set(this.activityAuditActivities, index, activity)

        try {
          this.loading = true
          await this.PUT_ACTIVITY_AUDIT_ACTIVITY(activity)
          this.loading = false
          this.$message({
            message: 'Activity Saved',
            type: 'success'
          })
        } catch (err) {
          this.loading = false
          this.$message({
            message: 'Error Editing Activity',
            type: 'error'
          })
        }
      },
      async deleteActivity(activity) {
        await this.$confirm(`Permanently delete ${activity.name}?  If it has been used on records it will be marked inactive instead.`, 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })

        try {
          this.loading = true
          await this.DELETE_ACTIVITY_AUDIT_ACTIVITY(activity)
          this.loading = false
          this.$message({
            message: 'Activity Removed',
            type: 'success'
          })
        } catch (err) {
          this.loading = false
          this.$message({
            message: `Error Deleting Activity: ${err.message}`,
            type: 'error'
          })
        }
      },
      closeNewActivityPopover() {
        const popper = this.$refs.newActivityPopover
        if (popper) {
          this.addActivityForm.name = null
          popper.doDestroy()
          popper.doClose()
        }
      }
    },
    computed: {
      ...mapState('managedLists/activityAuditActivities/', ['activityAuditActivities']),
      ...mapState('user/', ['currentTenantGuid'])
    }
  }
</script>

<style scoped>
  .topMargin {
    margin: 10px 0px 0px 0px;
  }

  >>>.VuePagination__count {
    display: none;
  }
</style>
